import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import history from "../history";
import { hideNavMenu, showMobilePopup, logout, triggeredMobilePopup } from "../actions";
import { useCategoryTree } from "../hooks/useAmplifyData";

const NavMenu = () => {
  const dispatch = useDispatch();
  const show_nav = useSelector(state => state.show_nav);
  const auth = useSelector(state => state.auth);

  const [showMenu, setShowMenu] = useState(true);
  const [showAccount, setShowAccount] = useState(false);
  const [showCategoryLevel1, setShowCategoryLevel1] = useState(true);
  const [showCategoryLevel2, setShowCategoryLevel2] = useState(false);
  const [showCategoryLevel3, setShowCategoryLevel3] = useState(false);
  const [level2Index, setLevel2Index] = useState(null);
  const [level2Heading, setLevel2Heading] = useState(null);
  const [level2EntityId, setLevel2EntityId] = useState(null);
  const [level3Index, setLevel3Index] = useState(null);
  const [level3Heading, setLevel3Heading] = useState(null);
  const [level3EntityId, setLevel3EntityId] = useState(null);

  // Fetch categories using Amplify Gen 2
  const { data: categories = [] } = useCategoryTree({ menuOnly: true });

  const handleHideNav = () => {
    dispatch(hideNavMenu());
  };

  const renderCategoriesLevel1 = () => {
    return categories.map((v, i) => {
      if (v.children.length > 0) {
        return (
          <a key={v.entity_id}>
            <div className="new-sm-nav-item">
              <div
                className="new-sm-nav-item-text"
                onClick={() => {
                  history.push(`/category/${v.entity_id}`);
                  handleHideNav();
                }}
              >
                {v.value}
              </div>
              <div
                className="new-sm-nav-item-caret"
                onClick={() => {
                  setLevel2Index(i);
                  setLevel2Heading(v.value);
                  setLevel2EntityId(v.entity_id);
                  setShowCategoryLevel1(false);
                  setShowCategoryLevel2(true);
                }}
              >
                <i className="fa fa-angle-right"></i>
              </div>
            </div>
          </a>
        );
      } else {
        return (
          <a
            key={v.entity_id}
            onClick={() => {
              history.push(`/category/${v.entity_id}`);
              handleHideNav();
            }}
          >
            <div className="new-sm-nav-item">{v.value}</div>
          </a>
        );
      }
    });
  };

  const renderCategoriesLevel2 = () => {
    if (level2Index === null) return null;

    const level2Categories = categories[level2Index].children.map((v, i) => {
      if (v.children.length > 0) {
        return (
          <a key={v.entity_id}>
            <div className="new-sm-nav-item">
              <div
                className="new-sm-nav-item-text"
                onClick={() => {
                  history.push(`/category/${v.entity_id}`);
                  handleHideNav();
                }}
              >
                {v.value}
              </div>
              <div
                className="new-sm-nav-item-caret"
                onClick={() => {
                  setLevel3Index(i);
                  setLevel3Heading(v.value);
                  setLevel3EntityId(v.entity_id);
                  setShowCategoryLevel2(false);
                  setShowCategoryLevel3(true);
                }}
              >
                <i className="fa fa-angle-right"></i>
              </div>
            </div>
          </a>
        );
      } else {
        return (
          <a
            key={v.entity_id}
            onClick={() => {
              history.push(`/category/${v.entity_id}`);
              handleHideNav();
            }}
          >
            <div className="new-sm-nav-item">{v.value}</div>
          </a>
        );
      }
    });

    return (
      <React.Fragment>
        <a
          className="new-sm-nav-item-caret-back"
          onClick={() => {
            setShowCategoryLevel1(true);
            setShowCategoryLevel2(false);
          }}
        ></a>
        <div
          className="categories-header"
          onClick={() => {
            history.push(`/category/${level2EntityId}`);
            handleHideNav();
          }}
        >
          {level2Heading}
        </div>
        {level2Categories}
      </React.Fragment>
    );
  };

  const renderCategoriesLevel3 = () => {
    if (level2Index === null || level3Index === null) return null;

    const level3Categories = categories[level2Index].children[level3Index].children.map(v => {
      return (
        <a
          key={v.entity_id}
          onClick={() => {
            history.push(`/category/${v.entity_id}`);
            handleHideNav();
          }}
        >
          <div className="new-sm-nav-item">{v.value}</div>
        </a>
      );
    });

    return (
      <React.Fragment>
        <a
          className="new-sm-nav-item-caret-back"
          onClick={() => {
            setShowCategoryLevel2(true);
            setShowCategoryLevel3(false);
          }}
        ></a>
        <div
          className="categories-header"
          onClick={() => {
            history.push(`/category/${level3EntityId}`);
            handleHideNav();
          }}
        >
          {level3Heading}
        </div>
        {level3Categories}
      </React.Fragment>
    );
  };

  let show_nav_menu_css = {};
  if (show_nav) {
    show_nav_menu_css = { left: '50%' };
  }

  let menu_active_css = "";
  if (showMenu) {
    menu_active_css = "sm-nav-active";
  }

  let account_active_css = "";
  if (showAccount) {
    account_active_css = "sm-nav-active";
  }

  return (
    <div id="new-sm-menu" style={show_nav_menu_css}>
      <a
        id="new-sm-menu-close"
        onClick={handleHideNav}
      >
        x
      </a>
      {showCategoryLevel1 && (
        <div id="new-sm-menu-nav-parent">
          <a
            id="new-sm-menu-nav-menu"
            className={`menu-nav ${menu_active_css}`}
            onClick={() => {
              setShowMenu(true);
              setShowAccount(false);
            }}
          >
            Menu
          </a>
          <a
            id="new-sm-menu-nav-account"
            className={`menu-nav ${account_active_css}`}
            onClick={() => {
              setShowMenu(false);
              setShowAccount(true);
            }}
          >
            Account
          </a>
        </div>
      )}
      {showMenu && (
        <div id="menu-menu-nav">
          {showCategoryLevel1 && (
            <div id="categories-level-1">
              <div id="new-sm-menu-buffer"></div>
              <a
                onClick={() => {
                  history.push('/browse');
                  handleHideNav();
                }}
              >
                <div className="new-sm-nav-item">Browse</div>
              </a>
              {renderCategoriesLevel1()}
            </div>
          )}
          {showCategoryLevel2 && (
            <div id="categories-level-2">{renderCategoriesLevel2()}</div>
          )}
          {showCategoryLevel3 && (
            <div id="categories-level-3">{renderCategoriesLevel3()}</div>
          )}
        </div>
      )}
      {showAccount && (
        <div id="account-nav">
          <div id="new-sm-menu-buffer"></div>
          {!auth.is_signed_in && (
            <a
              onClick={() => {
                dispatch(triggeredMobilePopup({ pathname: null }));
                dispatch(showMobilePopup());
              }}
            >
              <div id="account-nav-signin" className="new-sm-nav-item">
                Sign In
              </div>
            </a>
          )}
          {auth.is_signed_in && (
            <React.Fragment>
              <a
                onClick={() => {
                  history.push('/account');
                  handleHideNav();
                }}
              >
                <div id="account-nav-my-account" className="new-sm-nav-item">
                  My Account
                </div>
              </a>
              <a
                onClick={() => {
                  dispatch(logout(() => {
                    history.push('/browse');
                  }));
                  handleHideNav();
                }}
              >
                <div id="account-nav-signout" className="new-sm-nav-item">
                  Sign Out
                </div>
              </a>
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};

export default NavMenu;
